export default "__VITE_ASSET__C2G42uZh__"